import { IProductDetail } from '../../models/product-detail';
import { IResult } from '../../models/result-models';
import {
    CLEAR_PRODUCT_DETAILS_SUCCESS,
    LOAD_PRODUCT_DETAILS_SUCCESS,
    LOAD_RETURNING_PRODUCT_DETAILS_SUCCESS,
} from './product-detail-actions';

interface IClearProductDetailsSuccessAction {
    type: 'CLEAR_PRODUCT_DETAILS_SUCCESS';
}

interface ILoadProductDetailsSuccessAction {
    type: 'LOAD_PRODUCT_DETAILS_SUCCESS';
    result: IResult<IProductDetail>;
}
interface ILoadReturningProductDetailsSuccessAction {
    type: 'LOAD_RETURNING_PRODUCT_DETAILS_SUCCESS';
    result: IResult<IProductDetail>;
}
type KnownAction =
    | IClearProductDetailsSuccessAction
    | ILoadProductDetailsSuccessAction
    | ILoadReturningProductDetailsSuccessAction;

export const productDetailReducer = (
    state: IResult<IProductDetail> | null | undefined = null,
    action: KnownAction
) => {
    switch (action.type) {
        case CLEAR_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                ok: true,
                data: null,
            };
        case LOAD_PRODUCT_DETAILS_SUCCESS:
            return action.result;
        case LOAD_RETURNING_PRODUCT_DETAILS_SUCCESS:
            return action.result;
        default:
            return state;
    }
};
